import React from "react"

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              Privacy Policy / Politika e Privatësisë
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Last updated / Përditësuar së fundmi: 28/05/2025
            </p>
          </div>

          <div className="prose prose-gray dark:prose-invert max-w-none">
            {/* English Version */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 border-b border-gray-200 dark:border-gray-700 pb-2">
                English Version
              </h2>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Information We Collect
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We collect information you provide directly to us, such as when you create an account, 
                  update your profile, or contact us. This may include:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Name and contact information</li>
                  <li>Username and password</li>
                  <li>Email address</li>
                  <li>Profile information</li>
                  <li>Communications with us</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. How We Use Your Information
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Process transactions and send related information</li>
                  <li>Send technical notices and support messages</li>
                  <li>Respond to your comments and questions</li>
                  <li>Communicate with you about products, services, and events</li>
                  <li>Monitor and analyze trends and usage</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. Information Sharing and Disclosure
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We do not sell, trade, or otherwise transfer your personal information to third parties 
                  without your consent, except as described in this policy:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>With your consent</li>
                  <li>To comply with legal obligations</li>
                  <li>To protect our rights and safety</li>
                  <li>In connection with a business transfer</li>
                  <li>With service providers who assist us</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Data Security
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We implement appropriate security measures to protect your personal information against 
                  unauthorized access, alteration, disclosure, or destruction. However, no method of 
                  transmission over the internet is 100% secure.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Cookies and Tracking Technologies
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We use cookies and similar tracking technologies to collect and track information about 
                  your use of our service. You can control cookies through your browser settings.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Your Rights and Choices
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  You have certain rights regarding your personal information:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Access and update your information</li>
                  <li>Delete your account</li>
                  <li>Opt out of communications</li>
                  <li>Request data portability</li>
                  <li>Object to processing</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Data Retention
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We retain your personal information for as long as necessary to provide our services 
                  and fulfill the purposes outlined in this policy, unless a longer retention period 
                  is required by law.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Children's Privacy
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Our service is not intended for children under 13 years of age. We do not knowingly 
                  collect personal information from children under 13.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  9. Changes to This Policy
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We may update this privacy policy from time to time. We will notify you of any 
                  changes by posting the new policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  10. Contact Us
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  If you have any questions about this Privacy Policy, please contact us:
                </p>
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <p className="text-gray-700 dark:text-gray-300">
                    Email: privacy@merrvesh.com
                  </p>
                </div>
              </section>
            </div>

            {/* Albanian Version */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 border-b border-gray-200 dark:border-gray-700 pb-2">
                Versioni Shqip
              </h2>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Informacionet që Mbledhim
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne mbledhim informacionet që na jepni drejtpërdrejt, si kur krijoni një llogari, 
                  përditësoni profilin tuaj, ose na kontaktoni. Këto mund të përfshijnë:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Emri dhe informacionet e kontaktit</li>
                  <li>Emri i përdoruesit dhe fjalëkalimi</li>
                  <li>Adresa e emailit</li>
                  <li>Informacionet e profilit</li>
                  <li>Komunikimet me ne</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. Si i Përdorim Informacionet Tuaja
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne përdorim informacionet që mbledhim për të:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Ofruar, mirëmbajtur dhe përmirësuar shërbimet tona</li>
                  <li>Procesuar transaksionet dhe dërguar informacione të lidhura</li>
                  <li>Dërguar njoftimet teknike dhe mesazhet e mbështetjes</li>
                  <li>Përgjigjur komenteve dhe pyetjeve tuaja</li>
                  <li>Komunikuar me ju për produkte, shërbime dhe ngjarje</li>
                  <li>Monitoruar dhe analizuar tendencat dhe përdorimin</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. Ndarja dhe Zbulimi i Informacioneve
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne nuk shesim, shkëmbejmë ose transferojmë informacionet tuaja personale tek palët e treta 
                  pa pëlqimin tuaj, përveç siç përshkruhet në këtë politikë:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Me pëlqimin tuaj</li>
                  <li>Për të respektuar detyrimet ligjore</li>
                  <li>Për të mbrojtur të drejtat dhe sigurinë tonë</li>
                  <li>Në lidhje me një transferim biznesi</li>
                  <li>Me ofruesit e shërbimeve që na ndihmojnë</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Siguria e të Dhënave
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne zbatojmë masa të përshtatshme sigurie për të mbrojtur informacionet tuaja personale 
                  kundër aksesit të paautorizuar, ndryshimit, zbulimit ose shkatërrimit. Megjithatë, 
                  asnjë metodë e transmetimit përmes internetit nuk është 100% e sigurt.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Cookies dhe Teknologjitë e Gjurmimit
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne përdorim cookies dhe teknologji të ngjashme gjurmimi për të mbledhur dhe gjurmuar 
                  informacione për përdorimin tuaj të shërbimit tonë. Ju mund të kontrolloni cookies 
                  përmes cilësimeve të shfletuesit tuaj.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Të Drejtat dhe Zgjedhjet Tuaja
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ju keni të drejta të caktuara lidhur me informacionet tuaja personale:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Aksesoni dhe përditësoni informacionet tuaja</li>
                  <li>Fshini llogarinë tuaj</li>
                  <li>Refuzoni komunikimet</li>
                  <li>Kërkoni portabilitetin e të dhënave</li>
                  <li>Kundërshtoni përpunimin</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Ruajtja e të Dhënave
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne ruajmë informacionet tuaja personale për aq kohë sa është e nevojshme për të ofruar 
                  shërbimet tona dhe për të përmbushur qëllimet e përshkruara në këtë politikë, përveç 
                  nëse kërkohet një periudhë më e gjatë ruajtjeje nga ligji.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Privatësia e Fëmijëve
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Shërbimi ynë nuk është i destinuar për fëmijë nën 13 vjeç. Ne nuk mbledhim me dijeni 
                  informacione personale nga fëmijët nën 13 vjeç.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  9. Ndryshimet në këtë Politikë
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Mund të përditësojmë këtë politikë privatësie herë pas here. Do t'ju njoftojmë për 
                  çdo ndryshim duke postuar politikën e re në këtë faqe dhe duke përditësuar datën 
                  "Përditësuar së fundmi".
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  10. Na Kontaktoni
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Nëse keni ndonjë pyetje për këtë Politikë Privatësie, ju lutemi na kontaktoni:
                </p>
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <p className="text-gray-700 dark:text-gray-300">
                    Email: privacy@merrvesh.com
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy 